import { gql } from "@apollo/client";

//Navigation
export const NAVIGATION_QUERY = gql`
  query CANavigationCollection($dashboardIds: [UUID!]) {
    cANavigationCollection {
      items {
        url
        sortOrder
        isExternal
        active
        title
        types
        dashboard(
          where: { _system: { id: { in: $dashboardIds } } }
        ) {
          items {
            displayName
            _system { id }
          }
        }
      }
    }
  }
`;


//Academy
export const CAAcademyQuery = gql`
  query CAAcademyCollection($dashboardListId: [UUID!]) {
    cAAcademyCollection {
      items {
        _system {
          id
          lastPublished
          firstPublished
        }
        headline
        description
        regDeadline
        eventDate
        eventTime
        buttonUrl
        buttonText
        postedDate
        endDate
        feature
        dashboard(where: { _system: { id: { in: $dashboardListId } } }) {
          items {
            displayName
            dashboardRegion
            _system {
              id
              firstPublished
              lastPublished
            }
          }
        }
      }
    }
  }
`;
//Announcement
export const Announcement_QUERY = gql`
  query CAAnnouncementsCollection($dashboardListId: [UUID!]) {
    cAAnnouncementsCollection(sort: { postedDate: DESC }) {
      items {
        headline
        message
        buttonUrl
        buttonText
        postedDate
        endDate
        feature
        dashboard(where: { _system: { id: { in: $dashboardListId } } }) {
          items {
            _system {
              id
            }
            displayName
            dashboardRegion
          }
        }
        _system {
          id
          lastPublished
        }
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
      }
    }
  }
`;

//Key Contact Information
export const KEY_CONTACT_INFORMATION_QUERY = gql`
  query CAContactInfoCollection($dashboardListId: [UUID!]) {
    cAContactInfoCollection(sort: { _system: { lastPublished: DESC } }) {
      items {
        name
        title
        email
        phoneNumber
        _system {
          id
          firstPublished
          lastPublished
        }
        dashboard(where: { _system: { id: { in: $dashboardListId } } }) {
          items {
            displayName
            _system {
              id
            }
          }
        }
      }
    }
  }
`;

//Get Roles records
export const ROLES_QUERY = gql`
  query CARolesCollection($roleValue: String!) {
    cARolesCollection(where: { roleValue: { eq: $roleValue } }) {
      items {
        roleValue
        roleDisplayName
        dashboard {
          items {
            displayName
            _system {
              id
            }
          }
        }
      }
    }
  }
`;
// GG_WU_Portal_CA_Marketing_Support_West
export const ROLES_QUERY_LIST = gql`
  query CARolesCollection($roleValues: [String!]) {
    cARolesCollection(where: { roleValue: { in: $roleValues } }) {
      items {
        _system {
          id
        }
        roleValue
        roleDisplayName
        dashboard {
          items {
            _system {
              id
            }
            displayName
          }
        }
      }
    }
  }
`;

export const DASHBOARD_RECORD_QUERY = gql`
  query CADashboardCollection($dashboardListId: [UUID!], $skip: Int) {
    cADashboardCollection(
      take: 100
      skip: $skip
      where: { _system: { id: { in: $dashboardListId } } }
    ) {
      items {
        displayName
        quickLinksOrder
        keyDatesDeadlinesOrder
        announcementsOrder
        academyCalendarOrder
        keyContactInformationOrder
        academyCalendarTitle
        priority
        _system {
          id
        }
      }
    }
  }
`;

// Get Group records based on the dashboard '54c700e7-36e2-41e9-bf94-1baebffea502', '83a34204-efda-4861-ae6d-b1248ea87ccd'
export const GROUP_RECORD_QUERY = gql`
  query CAGroupNameCollection($dashboardListId: [UUID!], $skip: Int) {
    cAGroupNameCollection(
      take: 100
      skip: $skip
      where: { feature: { eq: true } }
    ) {
      items {
        _system {
          id
          firstPublished
          lastPublished
        }
        title
        dashboard(where: { _system: { id: { in: $dashboardListId } } }) {
          items {
            _system {
              id
              firstPublished
              lastPublished
            }
            displayName
            quickLinksOrder
            keyDatesDeadlinesOrder
            announcementsOrder
            academyCalendarOrder
            keyContactInformationOrder
          }
        }
        resourceType
        feature
        accordionOpen
        buttonText
        buttonUrl
        orderBy
        accordionImageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
      }
    }
  }
`;

export const GROUP_RECORD_WITHOUT_DASHBOARD_QUERY = gql`
  query CAGroupNameCollection($skip: Int, $resourceType: String) {
    cAGroupNameCollection(
      take: 100
      skip: $skip
      where: { resourceType: { contains: $resourceType } }
    ) {
      items {
        _system {
          id
          firstPublished
          lastPublished
        }
        title
        resourceType
        feature
        accordionOpen
        buttonText
        buttonUrl
        orderBy
        accordionImageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
      }
    }
  }
`;

// Get Resources records based on cAResourcesCollection.Items._system.id
export const RESOURCE_RECORD_CAMPAIGN_QUERY = gql`
  query CAResourcesCollection($resourceAliasPath: String!) {
    cAResourcesCollection(where: { aliasPath: { eq: $resourceAliasPath } }) {
      items {
        _system {
          firstPublished
          lastPublished
          id
        }
        resourceType
        title
        shortDescription
        buttonURL
        buttonText
        feature
        groupName
        _system {
          id
          firstPublished
          lastPublished
        }
        aliasPath
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
      }
    }
  }
`;

// Get Resources records based on the group name
export const RESOURCE_RECORD_QUERY = gql`
  query CAResourcesCollection($resourceType: String!, $skip: Int) {
    cAResourcesCollection(
      take: 100
      skip: $skip
      where: {
        resourceType: { contains: $resourceType }
              }
    ) {
      items {
        _system {
          firstPublished
          lastPublished
          id
        }
        resourceType
        title
        shortDescription
        buttonURL
        buttonText
        feature
        groupName
        _system {
          id
          firstPublished
          lastPublished
        }
        aliasPath
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
      }
    }
  }
`;

export const RESOURCE_RECORD_QUERY_FEATURED = gql`
  query CAResourcesCollection($resourceType: String!, $skip: Int) {
    cAResourcesCollection(
      take: 100
      skip: $skip
      where: {
        resourceType: { contains: $resourceType }
        feature: { eq: true }
              }
    ) {
      items {
        _system {
          firstPublished
          lastPublished
          id
        }
        resourceType
        title
        shortDescription
        buttonURL
        buttonText
        feature
        groupName
        _system {
          id
          firstPublished
          lastPublished
        }
        aliasPath
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
      }
    }
  }
`;

export const RESOURCE_ASSET_QUERY_ALL = gql`
  query CAResourceAssetCollection($skip: Int) {
    cAResourceAssetCollection(take: 100, skip: $skip) {
      items {
        _system {
          id
          contentType
        }
        title
        imageContentHub {
          items {
            contentFile {
              name
              fileSize
              fileType
              width
              height
            }
          }
        }
        resource
        resourceFolderName
        assetCategory
        externalURL
      }
    }
  }
`;

// Resource Asset
export const RESOURCE_ASSET_QUERY = gql`
  query CAResourceAssetCollection {
    cAResourceAssetCollection {
      items {
        _system {
          id
          contentType
        }
        title
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
        resource
        resourceFolderName
        assetCategory
        externalURL
      }
    }
  }
`;

// Resource_Folder

export const Resource_Folder_Query_ALL = gql`
  query CAResourceFolderCollection($skip: Int) {
    cAResourceFolderCollection(take: 100, skip: $skip) {
      items {
        folderName
        orderBy
        _system {
          id
          firstPublished
          lastPublished
        }
      }
    }
  }
`;
export const Resource_Folder_Query = gql`
  query CAResourceFolderCollection {
    cAResourceFolderCollection {
      items {
        folderName
        orderBy
        _system {
          id
          firstPublished
          lastPublished
        }
      }
    }
  }
`;

// Asset_Category
export const Asset_Category_Query = gql`
  query CAAssetCategoryCollection {
    cAAssetCategoryCollection {
      items {
        categoryName
        orderBy
        _system {
          id
          firstPublished
          lastPublished
        }
      }
    }
  }
`;

//Header_Footer
export const HEADER_FOOTER_QUERY = gql`
  query CAMasterDataCollection {
    cAMasterDataCollection {
      items {
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
        imageContentHubFooterLogo {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
        footerLogoUrl
        footerText
        imageContnetHubFooterContentLogo {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
        facebookNavigation
        youtubeNavigation
        instagramNavigation
        linkedInNavigation
      }
    }
  }
`;

//Key-Dates-Deadliness
export const GET_FEATURED_KEY_DATE_DEADLINE = gql`
  query CAKeyDatesCollection($dashboardListId: [UUID!]) {
    cAKeyDatesCollection {
      items {
        _system {
          id
          firstPublished
          lastPublished
        }
        headline
        description
        buttonUrl
        buttonText
        deadline
        postedDate
        endDate
        feature
        dashboard(where: { _system: { id: { in: $dashboardListId } } }) {
          items {
            _system {
              id
            }
            displayName
            dashboardRegion
          }
        }
      }
    }
  }
`;

//Group name for specific resource type
export const GROUP_SPECIFIC_RECORD_QUERY_ALL = gql`
  query CAGroupNameCollection($skip: Int, $id: UUID) {
    cAGroupNameCollection(
      take: 100
      skip: $skip
      where: { _system: { id: { eq: $id } } }
    ) {
      items {
        title
        feature
        buttonText
        buttonUrl
        orderBy
        dashboard {
          items {
            displayName
          }
        }
        resourceType
        _system {
          id
          lastPublished
        }
      }
    }
  }
`;

export const GROUP_SPECIFIC_RECORD_QUERY = gql`
  query CAGroupNameCollection {
    cAGroupNameCollection {
      items {
        title
        feature
        buttonText
        buttonUrl
        orderBy
        dashboard {
          items {
            displayName
          }
        }
        resourceType
        _system {
          id
          lastPublished
        }
      }
    }
  }
`;

// Get CAResourceTypeCollection by one or more resource type ids.
export const RESOURCETYPE_RECORD_CAMPAIGN_QUERY = gql`
  query CAResourceTypeCollection($resourceTypeIds: [UUID!]) {
    cAResourceTypeCollection(where: { _system: { id: { in: $resourceTypeIds } } }) {
      items {
        _system {
          id
        }
        title
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
      }
    }
  }
`;

export const RESOURCETYPE_RECORD_QUERY_ALL = `
query CAResourceTypeCollection($skip: Int) {
    cAResourceTypeCollection(take: 100, skip: $skip) {
      items {
        _system {
          id
        }
        title
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
      }
    }
  }
`;

export const RESOURCETYPE_RECORD_QUERY = gql`
  query CAResourceTypeCollection($title: String) {
    cAResourceTypeCollection(where: { title: { eq: $title } }) {
      items {
        _system {
          id
        }
        title
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
      }
    }
  }
`;

export const RESOURCE_TYPE_QUERY_ALL = gql`
  query CAResourceTypeCollection($skip: Int, $id: UUID) {
    cAResourceTypeCollection(
      take: 100
      skip: $skip
      where: { _system: { id: { eq: $id } } }
    ) {
      items {
        title
        _system {
          id
        }
      }
    }
  }
`;

export const RESOURCE_TYPE_QUERY = gql`
  query CAResourceTypeCollection {
    cAResourceTypeCollection {
      items {
        title
        _system {
          id
        }
      }
    }
  }
`;

// Correct query for documents
export const DOCUMENTS_QUERY = gql`
  query CAResourceAssetCollection {
    cAResourceAssetCollection {
      items {
        title
        resourceFolderName
        resource {
          items {
            title
            shortDescription
            buttonURL
            buttonText
            feature
            resourceType {
              items {
                title
              }
            }
          }
        }
        asset {
          fileName
          path
          fileSize
          fileType
          width
          height
        }
        _system {
          id
          lastPublished
        }
      }
    }
  }
`;
//MyLinks
export const MY_LINKS_QUERY = gql`
  query CAMyLinksCollection {
    cAMyLinksCollection {
      items {
        _system {
          id
        }
        title
        url
        myLinksGroup
        dashboard {
          items {
            _system {
              id
            }
            displayName
          }
        }
        internalExternal
      }
    }
    cAMyLinksGroupCollection {
      items {
        myLinksGroupName
        _system {
          id
        }
        accordionOpen
      }
    }
  }
`;
